<template>
  <div v-if='item' class='object-explorer-container d-flex justify-content-center mx-0'>
    <select v-if="isUpdate==false || isUpdate==undefined" class='custom-select form-control input-padding float-left' v-model='selectedItem'>
      <option v-for='(prop, val) in item' :value="val" v-bind:key="val"> {{getLabel(val, allCustomFields, $ml)}}</option>
    </select>
    <select v-else class='custom-select form-control input-padding float-left' v-model='updateItem'>
      <option v-for='(prop, val) in item' :value="val" v-bind:key="val" > {{getLabel(val, allCustomFields, $ml)}}</option>
    </select>
    <div v-if='(subItem && isObject(subItem,selectedItem))' class='sub-item-container'>
      <object-explorer v-bind:item='subItem' v-on:change='childChanged' :selectedObject="subSelectedObj"></object-explorer>
    </div>
    
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'object-explorer',
    props: ['item','currentPath','selectedObject','updateObject','isUpdate'],
    data () {
      return {
        selectedItem: '',
        subItem: this.item[0],
        id: '',
        subSelectedObj:'',
        updateItem:''
      }
    },

    methods: {
      getLabel: function (value,acf,ml) {

        if (!value) return 'undefined'
        value = value.toString()

        var isObjectInArray = acf.filter(function (el) {
          return el._id.$oid == value;
        });
        
        if(isObjectInArray.length>0){
          return isObjectInArray[0]['name']
        }

        var labelsTr = {
          'organizations':ml.get('COMPAINES'),//Firma
          'x':'Aktiflik Durumu',
          'name':ml.get('COMPANY_NAME'),
          'isCandidate':ml.get('LEAD'),
          'contacts':ml.get('PERSONS'),
          'createdAt':ml.get('CREATION_DATE'),
          'emailAddresses':ml.get('EMAIL_ADDRESS'),
          'phoneNumbers':ml.get('PHONE_NUMBER'),
          'faxNumbers':ml.get('FAKS_NUMBER'),
          'taxNo':ml.get('TAX_NUMBER'),
          'taxOffice':ml.get('TAX_ADMINISTRATION'),
          'sector':ml.get('SECTOR'),
          'webAddr':ml.get('WEB_SITE'),
          'addr':ml.get('ADDRESS'),
          'country':ml.get('COUNTRY'),
          'city':ml.get('CITY'),
          'town':ml.get('DISTRICT'),
          'postalCode':ml.get('POST_CODE'),
          'done':ml.get('DONE'),
          'modifiedAt':ml.get('DATE_OF_UPDATE'),
          'activities':ml.get('ACTIVITIES'),//Aktivite
          'subject':ml.get('SUBJECT_ACTIVITY'),
          'done':ml.get('COMPLETION_STATUS'),
          'type':ml.get('TYPE_ACTIVITY'),
          'dueDate':ml.get('PLANNED_TIME'),
          'assignedTo':ml.get('ASSIGNED'),
          'assignor':ml.get('ASSIGNMENT'),
          'doneDate':ml.get('COMPLETION_TIME'),
          'duration':ml.get('COMPLETION_DURATION'),
          'dealId':ml.get('OPORTUNITY'),
          'contactId':ml.get('PERSON'),
          'orgId':ml.get('COMPANY'),
          'notes':ml.get('NOTES'),
          'deals':ml.get('OPPORTUNITIES'), //Fırsatlar
          'dealsContacts':ml.get('OPPORTUNITIES'), //Fırsatlar
          'title' :ml.get('OPPORTUNITY_NAME'),
          'value' :ml.get('VALUE'),
          'currency' :ml.get('CURRENCY'),
          'cuid' :ml.get('USER'),
          'stageId' :ml.get('STEP_SMALL'),
          'status' :ml.get('STATUS'),
          'lostReason' :ml.get('THE_REASON_FOR_THE_LOSS'),
          'addDate' :ml.get('ADDITION_DATE'),
          'rate' :ml.get('DEGREE'),
          'source' :ml.get('SOURCE'),
          'expectedDate' :ml.get('ESTIMATED_CLOSING'),
          'notes' :ml.get('NOTES'),
          'productList' :ml.get('PRODUCTS'),
          'activityList' :ml.get('MY_ACTIVITIES'),
          'activityListContacts' :ml.get('ACTIVITIES'),
          'activityListDeals' :ml.get('ACTIVITIES'),
          'closedDate' :ml.get('CLOSING_DATE'),
          'phone':ml.get('PHONE'),//contacts
          'fax':ml.get('FAX'),
          'gsm':'GSM',
          'email':ml.get('E_MAIL'),
          'n':ml.get('NAME'),
          'sn':ml.get('SURNAME'),
          'tck':ml.get('TCK'),
          'dob':ml.get('DATE_OF_BIRTH'),
          'wed_ann':ml.get('WEDDING_ANNIVERSARY'),
          'uid':ml.get('USER'),
          'organization':ml.get('COMPANY'),
          'jobTitle':ml.get('JOBTITLE'),
          'products':ml.get('PRODUCTS'),//Products
          'name':ml.get('NAME'),
          'code':ml.get('PRODUCT_CODE'),
          'unit':ml.get('UNIT_OF'),
          'tax':ml.get('VAT'),
          'prices':ml.get('PRICE'),
          'cuid':ml.get('USER'),
          'price':ml.get('PRICE'),
          'currency':ml.get('CURRENCY'),
          'brand':ml.get('BRAND'),
          'model':ml.get('MODEL'),
          'dealProducts':ml.get('OPPORTUNITY_PRODUCTS'),//dealProducts
          'productId':ml.get('PRODUCT'),
          'itemPrice':ml.get('PRICE'),
          'quantity':ml.get('QUANTITY'),
          'discountPercentage':ml.get('DISCOUNT_RATE'),
          'sum':ml.get('TOTAL'),
          'users':ml.get('USER'),//user
          'surName':ml.get('SURNAME'),  
          'updateDate':ml.get('DATE_OF_UPDATE'),
          'userRoleId':ml.get('USER_ROLE'),
          'address':ml.get('ADDRESS'),
          'activation':ml.get('IS_IT_ACTIVE'),


        }
        return labelsTr[value]
      },

      isObject: function (item) {
        // console.log(item);
        if (typeof item === 'object') {
          return true
        }
        return false
      },

      focusNext: function () {
      },

      childChanged: function (newValue) {
        // console.log("newValue child change")
        // console.log(newValue)
        // console.log(this.isUpdate);
        if(this.isUpdate==true){
          if (newValue.length > 0) {
            this.$emit('change', this.updateItem + '.' + newValue)
          } else {
            this.$emit('change', this.updateItem)
          }
        }
        else{
          if (newValue.length > 0) {
            this.$emit('change', this.selectedItem + '.' + newValue)
          } else {
            this.$emit('change', this.selectedItem)
          }
        }
        
      },

      extractItem: function (item) {
        // console.log(item);
        var isArray = Array.isArray(item)
        if (isArray) {
          if (this.isObject(item[0])) {
            this.subItem = item[0]
          } else {
            this.subItem = null
          }
        } else {
          this.subItem = item
        }
      },

      updateSubItem: function () {
        // console.log("updateSubItem")
        // console.log(this.selectedItem)
        if (this.selectedItem.length > 0) {
          this.extractItem(this.item[this.selectedItem])
          //console.log('Sub:' + JSON.stringify(this.subItem))
          this.$emit('change', this.selectedItem)
        } else {
          //console.log('Reset subitem')
          this.subItem = null
        }
      },
      editSubItem: function () {
        // console.log("editSubİtem")
        // console.log(this.updateItem)
        if (this.updateItem.length > 0) {
          this.extractItem(this.item[this.updateItem])
          //console.log('Sub:' + JSON.stringify(this.subItem))
          this.$emit('change', this.updateItem)
        } else {
          //console.log('Reset subitem')
          this.subItem = null
        }
      }
      
    },
 
    computed: {
      ...mapGetters(['allCustomFields'])
    },

    watch: {
      selectedItem: function () {
        // console.log(this.selectedItem)
        // console.log("this.selectedItem")
        this.updateSubItem()
        this.$emit('change', this.selectedItem)
      },
      updateItem: function () {
        // console.log("updateItem girildi");
        // console.log(this.updateItem);
        this.editSubItem()
        this.$emit('change', this.updateItem)
      },
      item: function () {
        
        this.selectedItem = ''
        if(this.isUpdate==true){
          this.editSubItem()
        }
        else{
          this.updateSubItem()
        }
        
      }
    },

    created: function () {
      this.id = Math.random().toString(36).substr(2)
        if(this.isUpdate==false || this.isUpdate==undefined){
          if(this.selectedObject&&this.selectedObject!==''){
            this.selectedItem = this.selectedObject.split('.')[0]
            if(this.selectedObject.indexOf(".")!==-1){
              this.subSelectedObj = this.selectedObject.substring(this.selectedObject.indexOf(".")+1)
            }
          } 
        }
        else{
          if(this.updateObject&&this.updateObject!==''){
            if(this.updateObject.key==='in'){
              if(this.updateObject.val[1].var.includes('.')==true){
                this.updateItem = this.updateObject.val[1].var.split('.')[0]
                if(this.updateObject.val[1].var.indexOf(".")!==-1){
                  this.subSelectedObj = this.updateObject.val[1].var.substring(this.updateObject.val[1].var.indexOf(".")+1)
                  // console.log(this.subSelectedObj);
                }
              }
              else{
                this.updateItem = this.updateObject.val[1].var
              }
              
            }
            else{
              if(this.updateObject.val[0].var.includes('.')==true){
                // console.log("girildi if içine");
                this.updateItem = this.updateObject.val[0].var.split('.')[0]
                if(this.updateObject.val[0].var.indexOf(".")!==-1){
                  this.subSelectedObj = this.updateObject.val[0].var.substring(this.updateObject.val[0].var.indexOf(".")+1)
                  // console.log(this.subSelectedObj);
                }
              }
              else{
                this.updateItem = this.updateObject.val[0].var
              }
              
            }
          }
        }
           
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .object-explorer-container {
    display: inline;
  }
  .object-explorer-container>*{
    margin:0 8px;
  }
  .form-control {
    width: 150px;
    height: 30px;
    font-size: 15px;
  }

  .sub-item-container {
    margin: 0;
    display: inline;
  }

@media screen and (min-width: 1366px) {
  .form-control {
    width: 200px;
    height: 42px;
    font-size: 18px;
  }
}

</style>
